const questions = [
  { question: '¿La PDA y la pantalla de cocina están incluidas?', answer: 'El software para PDA y cocina está incluido en el plan de cada TPV principal. Los dispositivos y el resto de equipos físicos se compran aparte.' },
  { question: '¿Puedo seguir usando mi datáfono?', answer: 'Sí. Puedes mantener tu datáfono habitual. Si eliges los pagos integrados de Hosty, se aplica una tarifa por operación que incluye Stripe y Hosty. Revisa las condiciones antes de activar el servicio.' },
  { question: '¿Tengo que pagar un extra por VeriFactu?', answer: 'No. VeriFactu forma parte de Hosty completo. Para ponerlo en marcha, configura los datos fiscales de tu negocio; estar incluido en el plan no significa que ya esté activado.' },
  { question: '¿Qué ayuda incluye la cuota?', answer: 'Las consultas sobre tu cuenta y facturación, las actualizaciones y la corrección de errores de Hosty están incluidas. La instalación y las intervenciones técnicas se presupuestan aparte, antes de empezar.' },
];

export function MarketingFaq() {
  return (
    <section className="section marketing-faq" aria-labelledby="faq-title">
      <div className="container marketing-faq__grid">
        <div>
          <span className="marketing-eyebrow">Antes de decidir</span>
          <h2 id="faq-title">Las cosas claras.</h2>
          <p className="muted">Qué incluye el plan y qué se contrata aparte.</p>
        </div>
        <div className="marketing-faq__items">
          {questions.map((item) => (
            <details key={item.question}>
              <summary>
                {item.question}
                <span aria-hidden="true" className="marketing-faq__indicator" />
              </summary>
              <p>{item.answer}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
